module.exports = __webpack_public_path__ + "static/Lisa-Sullivan-Invent-9d80fa244b300342b334eb41b4425ec6.webp";